// extracted by mini-css-extract-plugin
module.exports = {"carouselSO":"styles_carouselSO__23cCR","cardForm":"styles_cardForm__36jnD","cardArticleForm":"styles_cardArticleForm__20wCb","btn-fab":"styles_btn-fab__1hn7P"};